<template>
  <div class="page" :style="`width:${dispW}px; height:${dispH}px;color:white;`">
    <el-container style="line-height: 0px; border-bottom: 1px solid gray">
      <el-main :height="`${dispH}px;`">
        <el-row>
          <el-col>
            <MapForm
              :colorBarWidth="90"
              :isSelectVisibleBoolen="false"
              :indexInForm="0"
              parentForm="keratoconus"
              :dispW="dispW / 2 + 130"
              :dispH="dispH / 2 - 15"
              :mapValues="mapValues"
            ></MapForm>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <MapForm
              :colorBarWidth="90"
              :isSelectVisibleBoolen="false"
              :indexInForm="1"
              parentForm="keratoconus"
              :dispW="dispW / 2 + 130"
              :dispH="dispH / 2 - 15"
              :mapValues="mapValues"
            ></MapForm>
          </el-col>
        </el-row>
      </el-main>
      <el-aside width="580px" style="border-left: 1px solid rgba(255, 255, 255, 0.3)">
        <KeratoconusStd
          :mapValues="mapValues"
          :dispW="dispW / 2"
          :dispH="dispH / 2"
        ></KeratoconusStd
      ></el-aside>
    </el-container>
  </div>
</template>
<script>
import MapForm from "./MapForm.vue";
import KeratoconusStd from "./KeratoconusStd";
export default {
  name: "FourMaps",
  data() {
    return {};
  },
  mounted: function () {
    this.$emit("hide-waiting");
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 30
    },
    mapValues: {
      type: Object,
      default() {
        return {};
      }
    },
    value: Boolean
  },
  components: {
    MapForm,
    KeratoconusStd
  }
};
</script>
<style scoped lang="less">
/deep/ .el-main {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/Keratoconus.vue